<template>
  <div>
    <div class="vx-row w-full">
      <div class="vx-col w-full mb-6">
        <vs-input
          class="w-full"
          label="Адрес:"
          name="address"
          v-validate="'required'"
          :value="value.address"
          @input="handleInput('address', $event)"
        />
        <span class="text-danger text-sm" v-show="errors.has('address')">{{ errors.first('address') }}</span>
      </div>
      <div class="vx-col sm:w-1/2 w-full mb-6">
        <vs-input
          class="w-full"
          label="Широта:"
          name="latitude"
          v-validate="'required|decimal'"
          :value="value.latitude"
          @input="handleInput('latitude', $event)"
        />
        <span class="text-danger text-sm" v-show="errors.has('latitude')">{{ errors.first('latitude') }}</span>
      </div>
      <div class="vx-col sm:w-1/2 w-full mb-6">
        <vs-input
          class="w-full"
          label="Долгота:"
          name="longitude"
          v-validate="'required|decimal'"
          :value="value.longitude"
          @input="handleInput('longitude', $event)"
        />
        <span class="text-danger text-sm" v-show="errors.has('longitude')">{{ errors.first('longitude') }}</span>
      </div>
    </div>

    <vs-button
      @click.prevent="send"
    >
      Отправить
    </vs-button>
  </div>
</template>

<script>
export default {
  props: {
    value: {
      type: Object,
      required: true
    }
  },

  methods: {
    async send () {
      const validate = await this.$validator.validateAll()
      if (validate) this.$emit('send')
    },

    handleInput (key, value) {
      const payload = Object.assign({}, this.value)
      payload[key] = value
      this.$emit('input', payload)
    }
  }
}
</script>
